module.exports = __webpack_public_path__ + "static/media/0267_Small.87f5c22f.jpg";